import React from 'react';
import { motion } from 'framer-motion';
import { Squares2X2Icon } from '@heroicons/react/24/outline';

const KanbanBoardDemo: React.FC = () => {
  const positions = [
    { x: 36, y: 88 }, // To Do
    { x: 216, y: 128 }, // In Progress
    { x: 396, y: 88 }, // Done
    { x: 36, y: 88 },
  ];

  return (
    <div className="bg-gradient-to-br from-green-500 to-teal-600 rounded-2xl p-8 shadow-2xl">
      <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm relative overflow-hidden">
        <div className="flex items-center justify-between mb-4 text-white">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
              <Squares2X2Icon className="w-4 h-4 text-white" />
            </div>
            <span className="font-medium">Project Board</span>
          </div>
          <div className="text-sm">5 tasks</div>
        </div>

        {/* Columns */}
        <div className="grid grid-cols-3 gap-4">
          {/* To Do */}
          <div className="space-y-2">
            <div className="text-white text-xs font-medium">To Do</div>
            <div className="bg-white/20 rounded p-2 text-white text-xs">Design homepage</div>
            <div className="bg-white/20 rounded p-2 text-white text-xs">Review content</div>
          </div>
          {/* In Progress */}
          <div className="space-y-2">
            <div className="text-white text-xs font-medium">In Progress</div>
            <div className="bg-white/20 rounded p-2 text-white text-xs">User research</div>
          </div>
          {/* Done */}
          <div className="space-y-2">
            <div className="text-white text-xs font-medium">Done</div>
            <div className="bg-white/20 rounded p-2 text-white text-xs">Wireframes</div>
            <div className="bg-white/20 rounded p-2 text-white text-xs">Brand guidelines</div>
          </div>
        </div>

        {/* Floating card animating across columns */}
        <motion.div
          className="absolute top-0 left-0"
          animate={{ x: positions.map((p) => p.x), y: positions.map((p) => p.y) }}
          transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
        >
          <div className="bg-white/90 text-gray-800 text-xs rounded-md shadow-lg px-3 py-2 select-none">
            Move card across columns
          </div>
        </motion.div>

        {/* Cursor following the floating card */}
        <motion.div
          className="pointer-events-none absolute top-0 left-0"
          style={{ width: 18, height: 26 }}
          animate={{ x: positions.map((p) => p.x + 128), y: positions.map((p) => p.y - 8) }}
          transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
        >
          <svg viewBox="0 0 24 24" width="18" height="26" className="drop-shadow">
            <path d="M3 2l16 8-6 2 2 8-4-6-8 2z" fill="#fff" />
            <path d="M3 2l16 8-6 2 2 8-4-6-8 2z" fill="#000" opacity=".15" />
          </svg>
        </motion.div>

        {/* Click ripple */}
        <motion.span
          className="pointer-events-none absolute -translate-x-1/2 -translate-y-1/2 rounded-full border-2 border-white/70"
          style={{ width: 12, height: 12 }}
          animate={{
            x: positions.map((p) => p.x + 140),
            y: positions.map((p) => p.y + 4),
            scale: [0.6, 1.4, 0.6, 1.4],
            opacity: [0, 0.9, 0, 0.9],
          }}
          transition={{ duration: 6, repeat: Infinity, ease: 'linear' }}
        />
      </div>
    </div>
  );
};

export default KanbanBoardDemo;


